export default __webpack_public_path__ + "ff65b9be679c4d84291a0513462e82da.jpg";